export default __webpack_public_path__ + "static/ensniw-7b587fac433ce3e7ea1058ab8c35acb5.png";